import React from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import HiddenInputs from '../elements/HiddenInputs';
import Purchase from '../elements/Purchase';
import PurchaseConfirmation from '../elements/PurchaseConfirmation';
import { RootState } from '../redux/store';

import Picker from './picker/Picker';

function SoccerPlay() {
    const { t } = useTranslation();
    const { lines, stakes, lottery } = useSelector((state: RootState) => state.playStore);

    return (
        <>
            <PurchaseConfirmation />
            <HiddenInputs lines={lines} stakes={stakes} betType="simple" sequenceId={lottery.sportSequence?.id} />
            {lottery.sportSequence?.end_bet_date_formatted && (
                <p className="draw-date font-bold">
                    {t('playPicker.endBetDate')}:{' '}
                    <time dateTime={lottery.sportSequence.end_bet_date}>
                        {lottery.sportSequence.end_bet_date_formatted}
                    </time>
                </p>
            )}
            <div className="row row-picker no-gutters d-flex w-100 pick-wrapper soccer-wrapper">
                <div className="purchase w-100 play-pick-type user-guide-play-picker" id="purchase">
                    <div className="container play">
                        <div className="myaccount play-main play-lottery row">
                            <Picker />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row no-gutters w-100 justify-content-sm-between align-items-center">
                <Purchase />
            </div>
        </>
    );
}

export default SoccerPlay;
